import { render, staticRenderFns } from "./PropertyOnClick.vue?vue&type=template&id=369fe33c&scoped=true"
import script from "./PropertyOnClick.vue?vue&type=script&lang=js"
export * from "./PropertyOnClick.vue?vue&type=script&lang=js"
import style0 from "./PropertyOnClick.vue?vue&type=style&index=0&id=369fe33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369fe33c",
  null
  
)

export default component.exports